var _rect, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "url(#paint0_linear_114_29606)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 18.0103C31.6667 17.0909 31.3015 16.2091 30.6513 15.559L26.1077 11.0154C25.4576 10.3652 24.5758 10 23.6564 10H13.4667C11.5521 10 10 11.5521 10 13.4667V32.5333C10 34.4479 11.5521 36 13.4667 36H25.1869C23.2974 34.7437 21.987 32.6855 21.7417 30.3112C21.444 30.3478 21.1409 30.3667 20.8333 30.3667C16.7649 30.3667 13.4667 27.0685 13.4667 23C13.4667 18.9315 16.7649 15.6333 20.8333 15.6333C24.5016 15.6333 27.5436 18.3145 28.1067 21.8241C28.5588 21.7426 29.0244 21.7 29.5 21.7C30.2518 21.7 30.9788 21.8064 31.6667 22.0049V18.0103Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7008 19.5307C21.7008 19.0521 21.3128 18.6641 20.8341 18.6641C20.3555 18.6641 19.9674 19.0521 19.9674 19.5307V22.1307H18.6674C18.1888 22.1307 17.8008 22.5187 17.8008 22.9974C17.8008 23.4761 18.1888 23.8641 18.6674 23.8641H20.8341C21.3128 23.8641 21.7008 23.4761 21.7008 22.9974V19.5307Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6499 24.9001C29.337 24.5512 28.006 24.7671 26.9192 25.3971C27.0604 25.5373 27.1543 25.7267 27.1719 25.9407C27.2112 26.4177 26.8564 26.8362 26.3793 26.8755L24.8656 27.0002C24.5245 27.0283 24.1989 26.8531 24.0344 26.553C23.8699 26.2529 23.8975 25.8841 24.1046 25.6118C25.68 23.5405 28.4162 22.5128 31.0952 23.225C34.3582 24.0924 36.4009 27.2403 35.9348 30.4899C35.8668 30.9637 35.4276 31.2927 34.9538 31.2247C34.48 31.1568 34.151 30.7176 34.219 30.2438C34.5605 27.8634 33.0629 25.5416 30.6499 24.9001Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.764 28.9511C24.8192 28.4756 24.4786 28.0455 24.0031 27.9902C23.5276 27.935 23.0975 28.2757 23.0423 28.7511C22.6756 31.908 24.7269 34.9227 27.9254 35.7729C30.5955 36.4827 33.3254 35.49 34.896 33.4519C35.105 33.1808 35.1347 32.8121 34.972 32.5109C34.8093 32.2098 34.4846 32.0326 34.1433 32.0588L32.6319 32.1747C32.1546 32.2113 31.7974 32.6278 31.834 33.1051C31.85 33.3143 31.9391 33.5005 32.0744 33.6405C30.9981 34.2432 29.6789 34.4455 28.3707 34.0977C25.9845 33.4634 24.499 31.2323 24.764 28.9511Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_114_29606",
    x1: 23,
    y1: 26.895,
    x2: 23,
    y2: 0.992272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050D42"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.86cae88ad6c5b715b28c7826fe897589.svg";
export { ForwardRef as ReactComponent };